import { LOGIN_SUCCESS, LOGOUT, LOGIN_FAIL, SET_LOADING } from "../Types";

export default (state, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      sessionStorage.setItem("access_token", action.payload.access_token);
      sessionStorage.setItem("user_profile", action.payload.image);
      return {
        ...state,
        user: action.payload.image,
        isAuthenticated: true,
        loading: false,
      };
    case LOGOUT:
    case LOGIN_FAIL:
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("user_profile");
      return {
        ...state,
        access_token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
        error: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};
